import React from 'react';
import Couriers from '../../components/organisms/Couriers/Couriers';

const ConfirmedList = () => {
    return <Couriers url="/courier/confirmed-list" route="confirmed" />;
};

export default ConfirmedList;
